import {
  Alert,
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Input,
  Textarea,
  Typography,
} from "@material-tailwind/react";
import React, {useEffect, useState} from "react";
import SelectInput from "../system/select";
import {getPersonsNameAndFamily} from "../../services/profile/profile";
import {submitAdminServiceSendPaymentLink} from "../../services/admin_service/send_payment_link";
import persianNumberFormat from "../../helper/PersianNumberFormat";
import {BsCheckCircle} from "react-icons/bs";
import {Toaster} from "../../helper/Toaster";
import {LoadingOverlay} from "../system/loading_overlay";
import {DEFAULT_PAYMENT_METHOD, PAYMENT_GATEWAY_OPTIONS} from "../../helper/paymentGateway";


export function SendPaymentLink() {

  const [personId, setPersonId] = useState(null);
  const [description, setDescription] = useState("");
  const [value, setValue] = useState(10000);
  const [name, setName] = useState("")
  const [family, setFamily] = useState("")
  const [loading, setLoading] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState(DEFAULT_PAYMENT_METHOD);

  useEffect(() => {
    const new_description = `کاربر گرامی،
` +
      `لینک پرداخت به مبلغ ${persianNumberFormat(value, true)} ریال جهت دریافت مشاوره/ خدمات از پلتفرم کسب و کار مباشر خدمتتان ارسال شد.لطفا پس از پرداخت از طریق تماس با شماره 02191095190 به پلتفرم مباشر اطلاع رسانی نمائید.
` +
      "پلتفرم مباشر\n"
    setDescription(new_description);
  }, [value, name, family]);

  const [link, setLink] = useState("")

  const save = async () => {
    if (loading) return; // Prevent multiple simultaneous requests
    
    const data = {
      person_id: personId,
      description: description,
      value: value,
      payment_method: paymentMethod,
    };
    
    try {
      setLoading(true);
      let result = await submitAdminServiceSendPaymentLink(data);

      if (result.status === 200) {
        setPersonId(null);
        setDescription("");
        setValue(10000);
        setPaymentMethod(DEFAULT_PAYMENT_METHOD);
        const {payment_link} = result.data;
        setLink(payment_link);
      } else {
        Toaster.failure(null, <Typography variant="small">
          {result.data?.message || 'خطا در ارسال لینک پرداخت'}
        </Typography>);
      }
    } catch (err) {
      Toaster.failure(null, <Typography variant="small">
        {err.message || 'خطا در ارسال لینک پرداخت'}
      </Typography>);
      console.error('Send payment link error:', err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mr-8">
      <Card className="relative pt-8 md:w-1/2">
        {loading && <LoadingOverlay message="در حال ارسال لینک پرداخت..."/>}
        <CardHeader floated={true} shadow={false} className="rounded-none">
          <div className="mb-8 flex text-center items-center justify-between gap-8">
            <Typography variant="h5" color="blue-gray">ارسال لینک پرداخت</Typography>
          </div>

          {link &&
            <div className="">
              <Alert className="flex flex-row my-4">
                <Typography className="flex font-semibold">
                  <BsCheckCircle className="flex ml-2 text-xl"/>
                  لینک پرداخت با موفقیت ارسال گردید.
                </Typography>
                <Typography>
                  {link}
                </Typography>
              </Alert>
            </div>
          }

        </CardHeader>
        <CardBody className="overflow-x-auto w-full">
          <div className="grid grid-cols-1">

            <div className="flex w-full mb-4">
              <SelectInput
                label={"کاربر"}
                defaultValue={personId}
                autoLoadService={getPersonsNameAndFamily}
                name={name}
                setName={setName}
                family={family}
                setFamily={setFamily}
                autoLoadRender={({name, family, phone}) => {
                  const fullName = `${name?.trim()} ${family?.trim()}`.trim();
                  return fullName + " - " + phone
                }}
                onChange={setPersonId}
              />
            </div>

            <div className="flex w-full mb-4">
              <Textarea
                label="متن پیام"
                type="number"
                variant="standard"
                step="5"
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                }}
              />
            </div>

            <div className="flex w-full my-4">
              <Input
                label="مبلغ (ریال)"
                type="number"
                variant="standard"
                step="5"
                min={"10000"}
                value={value}
                onChange={(e) => {
                  setValue(parseInt(e.target.value));
                }}
              />
            </div>

            <div className="flex w-full my-4">
              <SelectInput
                label="درگاه پرداخت"
                defaultValue={paymentMethod}
                refreshSignal={paymentMethod}
                options={PAYMENT_GATEWAY_OPTIONS}
                onChange={setPaymentMethod}
              />
            </div>

            <div>
              <Typography>
                {`مبلغ (ریال): ${persianNumberFormat(value, true)}`}
              </Typography>
            </div>


          </div>
        </CardBody>

        <CardFooter className="flex items-center justify-center border-t border-blue-gray-50 p-4">
          <Button variant="gradient" color="gray" onClick={save} className="ml-1" disabled={loading} loading={loading}>
            {loading ? 'در حال ارسال...' : 'ارسال لینک پرداخت'}
          </Button>
        </CardFooter>
      </Card>
    </div>
  );
}
